export const SEND_DATA = 'SEND_DATA';
export const GET_BROKER_DATA = 'GET_BROKER_DATA';